export default (props, vars) => !!props?.['isOutstanding'];
